// extracted by mini-css-extract-plugin
module.exports = {"stepper":"style_stepper__3r7ye","commitDialog":"style_commitDialog__pCLZR","commitDialogNote":"style_commitDialogNote__3Agu-"};